/*
Akhila 05/16/2023 bug fixed EST time zone implemented
*/
import React, {useEffect, useState, useRef} from 'react';
import {Grid, TablePagination} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import {tableIcons} from './../../../components/TableIcons/index';
import {httpPaginationPost} from './../../../util/Rest';
import {defaultRows} from '../../../constants/ReusableTablePagination';
import GuiTable from './../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../constants/ReusableConstants';
import moment from 'moment';

export default function WorkQueueSearchTable({
  setSubmit,
  submit,
  searchData,
  reportMasterSearch,
  setWorkQueueRowData,
  setTabValue,
}) {
  const columns = [
    {
      title: 'Work Queue Name',
      field: 'workQueueCode',
      render: (rowData) => (
        <div
          className="wq-accountNumber"
          role="button"
          tabIndex="0"
          onClick={() => {
            setTabValue(1);
            setWorkQueueRowData(rowData);
          }}
        >
          {rowData?.workQueueCode}
        </div>
      ),
    },
    {
      title: 'User Name',
      field: 'userName',
    },
    {
      title: 'Accounts Opened',
      field: 'accountsOpened',
    },
    {
      title: 'Accounts Worked',
      field: 'accountsWorked',
    },
    {
      title: 'Start Date',
      field: 'workStartDttm',
      render: (rowData) => {
        return rowData?.workStartDttm ?
          moment(rowData?.workStartDttm).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A') :
          '';
      },
    },
    {
      title: 'End Date',
      field: 'lastUpdatedDttm',
      render: (rowData) => {
        return rowData?.lastUpdatedDttm ?
          moment(rowData?.lastUpdatedDttm).tz('America/New_York').format('MM/DD/YYYY hh:mm:ss A') :
          '';
      },
    },
  ];
  const tableRef = useRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);

  useEffect(() => {
    if (tableRef.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);

  const SearchSessionWorkQueue = JSON.parse(sessionStorage.getItem('WorkQueueActivity'));
  if (SearchSessionWorkQueue && !submit) {
    searchData = SearchSessionWorkQueue;
  }

  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `workqueu/search/all`;
                const bodyObj = {
                  workQueueCode: searchData?.workQueueCode ? searchData.workQueueCode : '',
                  userName: searchData?.userName ? searchData.userName : '',
                  limit: query.pageSize ? query.pageSize : null,
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  orderDirection: query.orderDirection,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  workStartDttm: searchData?.workStartDttm ?
                    moment(searchData?.workStartDttm).format('MM/DD/YYYY') : // searchData?.workStartDttm
                    '',
                  endDate: searchData?.lastUpdatedDttm ?
                    moment(searchData?.lastUpdatedDttm).format('MM/DD/YYYY') : // searchData?.lastUpdatedDttm
                    '',
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: false,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbarButtonAlignment: 'left',
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            localization={{
              header: {
                actions: reportMasterSearch ? '' : 'Actions',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer new-standard-textfields">
                  <div className="mt-2"></div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}
